const LENS_PATH = /^\/ask-richard\/lens\/([^/]+)\/?$/;

export function lensIdFromPath(pathname: string): string | null {
  const match = pathname.match(LENS_PATH);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function lensPath(lensId: string): string {
  return `/ask-richard/lens/${encodeURIComponent(lensId)}`;
}
